import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_1ab12206 from 'nuxt_plugin_plugin_1ab12206' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_recaptcha_ee09654c from 'nuxt_plugin_recaptcha_ee09654c' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_nuxtplugin6109a844_7dce03fc from 'nuxt_plugin_nuxtplugin6109a844_7dce03fc' // Source: ./nuxt.plugin.6109a844.js (mode: 'server')
import nuxt_plugin_vuescrollto_43be5b3e from 'nuxt_plugin_vuescrollto_43be5b3e' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_46c25613 from 'nuxt_plugin_cookieuniversalnuxt_46c25613' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_c9d6f5a0 from 'nuxt_plugin_pluginutils_c9d6f5a0' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginseo_64d7f6f8 from 'nuxt_plugin_pluginseo_64d7f6f8' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_43eef30a from 'nuxt_plugin_pluginrouting_43eef30a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_bf092258 from 'nuxt_plugin_pluginmain_bf092258' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_distplugin2892d321_16c80972 from 'nuxt_plugin_distplugin2892d321_16c80972' // Source: ./dist.plugin.2892d321.mjs (mode: 'all')
import nuxt_plugin_image_a5b02d34 from 'nuxt_plugin_image_a5b02d34' // Source: ./image.js (mode: 'all')
import nuxt_plugin_corepluginff7bd284_4f76dd82 from 'nuxt_plugin_corepluginff7bd284_4f76dd82' // Source: ./core.plugin.ff7bd284.ts (mode: 'all')
import nuxt_plugin_pluginse2etestingc9e8bbc4_120ce85c from 'nuxt_plugin_pluginse2etestingc9e8bbc4_120ce85c' // Source: ./plugins.e2e-testing.c9e8bbc4.js (mode: 'all')
import nuxt_plugin_deviceplugin_74b22e14 from 'nuxt_plugin_deviceplugin_74b22e14' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_workbox_3f67f2c7 from 'nuxt_plugin_workbox_3f67f2c7' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_meta_41012d13 from 'nuxt_plugin_meta_41012d13' // Source: ./pwa/meta.js (mode: 'all')
import nuxt_plugin_icons_63be8508 from 'nuxt_plugin_icons_63be8508' // Source: ./pwa/icons.js (mode: 'all')
import nuxt_plugin_tokenexpired_ca1e20ca from 'nuxt_plugin_tokenexpired_ca1e20ca' // Source: ../plugins/token-expired (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_fcPlugin_5a846bc6 from 'nuxt_plugin_fcPlugin_5a846bc6' // Source: ../plugins/fcPlugin (mode: 'all')
import nuxt_plugin_dompurify_9e093c4a from 'nuxt_plugin_dompurify_9e093c4a' // Source: ../plugins/dompurify (mode: 'all')
import nuxt_plugin_storeConfigPlugin_234467e0 from 'nuxt_plugin_storeConfigPlugin_234467e0' // Source: ../plugins/storeConfigPlugin (mode: 'all')
import nuxt_plugin_helloextend_bc4a9d94 from 'nuxt_plugin_helloextend_bc4a9d94' // Source: ../plugins/helloextend (mode: 'all')
import nuxt_plugin_deferredscriptsclient_58b963a4 from 'nuxt_plugin_deferredscriptsclient_58b963a4' // Source: ../plugins/deferred-scripts.client.ts (mode: 'client')
import nuxt_plugin_vuetinyslider_67155006 from 'nuxt_plugin_vuetinyslider_67155006' // Source: ../plugins/vue-tiny-slider.js (mode: 'client')
import nuxt_plugin_pinterestTag_71f3ee21 from 'nuxt_plugin_pinterestTag_71f3ee21' // Source: ../plugins/pinterestTag.js (mode: 'client')
import nuxt_plugin_shopperapproved_3a7a0d0f from 'nuxt_plugin_shopperapproved_3a7a0d0f' // Source: ../plugins/shopperapproved.js (mode: 'client')
import nuxt_plugin_meta_f6ae3562 from 'nuxt_plugin_meta_f6ae3562' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Mpex","meta":[{"charset":"utf8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"robots","content":"index, follow"},{"hid":"description","name":"description","content":"Midwest Photo"},{"name":"generator","content":"Vue Storefront 2"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Fsite-assets.fontawesome.com\u002Freleases\u002Fv6.5.1\u002Fcss\u002Fall.css"}],"script":[{"src":"https:\u002F\u002Fsdk.helloextend.com\u002Fextend-sdk-client\u002Fv1\u002Fextend-sdk-client.min.js","async":true,"body":true},{"src":"https:\u002F\u002Fstatic.klaviyo.com\u002Fonsite\u002Fjs\u002Fklaviyo.js?company_id=SJMjht","async":true,"type":"text\u002Fjavascript","body":true},{"type":"external","src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-EYHDSMCYF4","attrs":{"async":"true"}},{"type":"inline","id":"syfWidgetObject","content":"\n            window.syfWidgetObject = {\n              syfPartnerId: \"PI2001420501\",\n              flowType: \"PDP\",\n            };\n          "},{"hid":"gtm-script","innerHTML":"\n            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer','GTM-WQ3HLQD');\n          ","type":"text\u002Fjavascript"}],"noscript":[{"hid":"gtm-noscript","innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-WQ3HLQD\"\n          height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"\u003E\u003C\u002Fiframe\u003E","body":true},{"hid":"pinterest-noscript","innerHTML":"\u003Cimg height=\"1\" width=\"1\" style=\"display:none;\" alt=\"\"\n          src=\"https:\u002F\u002Fct.pinterest.com\u002Fv3\u002F?event=init&tid=2613467394920&pd[em]=midwestphotoex@gmail.com&noscript=1\" \u002F\u003E","body":true}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"pinterest-script":["innerHTML"],"gtm-noscript":["innerHTML"],"pinterest-noscript":["innerHTML"],"syfWidgetObject":["innerHTML"]},"style":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_1ab12206 === 'function') {
    await nuxt_plugin_plugin_1ab12206(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_ee09654c === 'function') {
    await nuxt_plugin_recaptcha_ee09654c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nuxtplugin6109a844_7dce03fc === 'function') {
    await nuxt_plugin_nuxtplugin6109a844_7dce03fc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_43be5b3e === 'function') {
    await nuxt_plugin_vuescrollto_43be5b3e(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_46c25613 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_46c25613(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_c9d6f5a0 === 'function') {
    await nuxt_plugin_pluginutils_c9d6f5a0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_64d7f6f8 === 'function') {
    await nuxt_plugin_pluginseo_64d7f6f8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_43eef30a === 'function') {
    await nuxt_plugin_pluginrouting_43eef30a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_bf092258 === 'function') {
    await nuxt_plugin_pluginmain_bf092258(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin2892d321_16c80972 === 'function') {
    await nuxt_plugin_distplugin2892d321_16c80972(app.context, inject)
  }

  if (typeof nuxt_plugin_image_a5b02d34 === 'function') {
    await nuxt_plugin_image_a5b02d34(app.context, inject)
  }

  if (typeof nuxt_plugin_corepluginff7bd284_4f76dd82 === 'function') {
    await nuxt_plugin_corepluginff7bd284_4f76dd82(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginse2etestingc9e8bbc4_120ce85c === 'function') {
    await nuxt_plugin_pluginse2etestingc9e8bbc4_120ce85c(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_74b22e14 === 'function') {
    await nuxt_plugin_deviceplugin_74b22e14(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_3f67f2c7 === 'function') {
    await nuxt_plugin_workbox_3f67f2c7(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_41012d13 === 'function') {
    await nuxt_plugin_meta_41012d13(app.context, inject)
  }

  if (typeof nuxt_plugin_icons_63be8508 === 'function') {
    await nuxt_plugin_icons_63be8508(app.context, inject)
  }

  if (typeof nuxt_plugin_tokenexpired_ca1e20ca === 'function') {
    await nuxt_plugin_tokenexpired_ca1e20ca(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_fcPlugin_5a846bc6 === 'function') {
    await nuxt_plugin_fcPlugin_5a846bc6(app.context, inject)
  }

  if (typeof nuxt_plugin_dompurify_9e093c4a === 'function') {
    await nuxt_plugin_dompurify_9e093c4a(app.context, inject)
  }

  if (typeof nuxt_plugin_storeConfigPlugin_234467e0 === 'function') {
    await nuxt_plugin_storeConfigPlugin_234467e0(app.context, inject)
  }

  if (typeof nuxt_plugin_helloextend_bc4a9d94 === 'function') {
    await nuxt_plugin_helloextend_bc4a9d94(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_deferredscriptsclient_58b963a4 === 'function') {
    await nuxt_plugin_deferredscriptsclient_58b963a4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetinyslider_67155006 === 'function') {
    await nuxt_plugin_vuetinyslider_67155006(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pinterestTag_71f3ee21 === 'function') {
    await nuxt_plugin_pinterestTag_71f3ee21(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_shopperapproved_3a7a0d0f === 'function') {
    await nuxt_plugin_shopperapproved_3a7a0d0f(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_f6ae3562 === 'function') {
    await nuxt_plugin_meta_f6ae3562(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
